import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import styled from 'styled-components';
import {
    // TopWrapperVideo,
    // TopWrapperVideoContent,
    VideoContent,
    VideoPlayerWrapper,
    VideoWrapper
} from '../../../style/VideoStyle';
import Button from '../../../components/button';
import Navigation from '../../../components/Navigation/Navigation';
import { FormWrapPopup, MainWrapper, TopWrapper } from '../../../style/DasboardMain';
import { useSearchParams } from 'react-router-dom';
import {$apiV1, $apiV2, VIDEO_SERVICE_URL} from '../../../config/api';
import { getVideoName, groupEventsByTeam } from './helpers';
import { classifyCutResult, pickNextPlayableIndex } from './helpers/videoCutResult';
import { EventsPanel } from './ui/EventsPanel';
import { VideoPlayer } from './ui/VideoPlayer';
import Modal from "../../../components/modal/index";
import TextInput from '../../../components/inputs/TextInput';
// import { SelectDropdown } from '../../../style/Global';
import IntroText from "../../../components/introText/index";
import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from './ShotsPlayer';

import arrowIconUp from "../../../images/up.svg";
import arrowIconDown from "../../../images/down.svg";
import { useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import { useLexicon } from '../../../hooks/useLexicon';
import { useNotification } from '../../../components/notification/useNotification';
import { NotificationList } from '../../../components/notification/NotificationList';
import VideoTutorial from '../shared/ui/VideoTutorial';
import { getVideoList } from '../../../helpers/service';
import {
    areMarkerListsEqual,
    resolveTokenMarkerSources,
} from './helpers/videoMarkerScope';
import { trackPlaylistAction } from '../../../tracking';
import { useTranslation } from 'react-i18next';
import {
    findNearestPlayableClipIndex,
    getClipAccessSummary,
    isPlayableClip,
} from './helpers/videoAccess';


// True when an error is the result of an aborted request (fetch AbortController
// or an axios cancellation), so the superseded playback request can bail out
// quietly instead of surfacing an error.
const isAbortError = (error) =>
    error?.name === 'AbortError' ||
    error?.name === 'CanceledError' ||
    error?.code === 'ERR_CANCELED';

// Resolve marker events in batches of this size so a huge marker list (the
// /stats/markers_search endpoint loads a deep eager-loaded graph per marker and
// can exceed php-fpm memory at thousands of markers) is fetched incrementally:
// the first batch renders immediately and the rest stream in in the background.
const MARKER_BATCH_SIZE = 20;

// Background marker batches are appended to the list on at most this cadence, so
// the getPrepearedMarkers + list-render pipeline runs a handful of times for a
// large marker set instead of once per 20-marker batch.
const COALESCE_PUBLISH_MS = 250;

const chunkArray = (items, size) => {
    const chunks = [];
    for (let i = 0; i < items.length; i += size) {
        chunks.push(items.slice(i, i + size));
    }
    return chunks;
};

// Toggle UI styles (scoped to this file)
const AnalystToggleWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    margin-right: ${(props) => (props.$stacked ? '0px' : '50px')};  
    gap: 12px;
`;

const ToggleSwitch = styled.label`
    position: relative;
    display: inline-block;
    width: 38px;
    height: 22px;
`;

const ToggleInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`;

const ToggleSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.blueish3};
    transition: 0.4s;
    border-radius: 34px;

    &:before {
        position: absolute;
        content: '';
        height: 20px;
        width: 20px;
        left: 1px;
        bottom: 1px;
        background-color: #fff;
        transition: 0.4s;
        border-radius: 50%;
    }

    ${ToggleInput}:checked + & {
        background-color: ${(props) => props.theme.green};
    }

    ${ToggleInput}:checked + &:before {
        transform: translateX(16px);
    }
`;

// Full-screen blackout overlay when analyst mode is active
const AnalystOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    opacity: ${(props) => (props.$visible ? 1 : 0)};
    pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
    transition: opacity 0.3s ease-in-out;
    z-index: 1000;
`;

// Keep specific elements (like title) above overlay
const FocusLayer = styled.div`
    position: relative;
    z-index: ${(props) => (props.$focus ? 1002 : 'auto')};
`;

const VideoListUpdatedV2 = () => {
    const [searchParams] = useSearchParams();
    const isMergedView = searchParams.get('merged') === '1';
    // Immediate-events sequences: keep the single merged video, but build it
    // from only the selected markers so non-selected markers in the full set
    // never split it into several videos.
    const isSelectedOnlyMerge = searchParams.get('selected') === '1';
    // Set by Team/Player Events when a sequence-context filter was selected.
    // It applies to every event chosen in this viewer, including replays of
    // the currently selected list item.
    const startWithFullSequence = searchParams.get('full_sequence') === '1';
    const l = useLexicon();
    const { t } = useTranslation();
    const [title, setTitle] = useState('');
    const { offset_range_begin = 10, offset_range_end = 10, merge_offset } = useSelector(state => state.user.userProfile);
    const [videoSettings, setVideoSettings] = useState(null);
    // Call video settings endpoint on page load
    useEffect(() => {
        $apiV2
            .get('/user/video_settings').then(res => {
                setVideoSettings(res.data);
            }).catch((err) => console.log('Error fetching /user/video_settings:', err?.message));
    }, []);

    const { notifications, addNotification, removeNotification } = useNotification();

    const [countEpisode, setCountEpisode] = useState(0);
    const [countMatches, setCountMatches] = useState(0);
    const [countSequences, setCountSequences] = useState(0);
    const [videoCutsServer, setVideoCutsServer] = useState([]);
    const [videoCuts, setVideoCuts] = useState([]);
    const [videoCutsForHandleVideo, setVideoCutsForHandleVideo] = useState([]);
    const [videoHref, setVideoHref] = useState('');
    const [videoSecond, setVideoSecond] = useState(0);

    const [loadingVideo, setLoadingVideo] = useState(false);
    const isCutLoadingRef = useRef(false);

    const [openAddVideo, setOpenAddVide] = useState(false);
    const [folderName, setFolderName] = useState("");

    const [userPlaylists, setUserPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loadingAddPlaylist, setLoadingAddPlaylist] = useState(false);

    const [record, setRecord] = useState(null);
    const [recordTime, setRecordTime] = useState(null);
    // True while the player is showing the expanded full possession sequence
    // for the current event (so the chip offers "Show event only"). The origin
    // ref keeps the original single-event marker to restore from.
    const [showFullSequence, setShowFullSequence] = useState(false);
    const fullSequenceOriginRef = useRef(null);
    // Representative marker ids of the possession sequences chronologically
    // adjacent to the one currently shown, so "Show previous/next sequence" can
    // step through the match by re-querying the sequence endpoint. Null at the
    // ends of the match (button disabled).
    const [sequenceNav, setSequenceNav] = useState({ prevMarkerId: null, nextMarkerId: null });
    // Aborts the in-flight playback request (access check + /cut fetch) so that
    // switching between the event clip and the full sequence — in either
    // direction — cancels the load that is no longer wanted instead of waiting
    // for it. The request id guards stale completions from clobbering state.
    const playbackAbortRef = useRef(null);
    const playbackRequestIdRef = useRef(0);

    // Aborts the in-flight marker-resolution batches when the marker set changes
    // or the user leaves the page, so superseded/abandoned loads stop immediately.
    const markersLoadAbortRef = useRef(null);
    // When true, the next videoCutsServer update came from a background batch
    // append and must not restart the clip the user is currently watching.
    const suppressAutoPlayRef = useRef(false);
    // "<index>:<replayNonce>" of the clip last sent to the player. Background
    // batches keep rebuilding videoCutsForHandleVideo (new array ref) without
    // changing the selection; without this guard the playback effect would
    // re-run handlePlayVideo on every batch and keep the loading spinner up
    // (over the already-playing clip) until the last batch arrived.
    const lastPlayedSelectionRef = useRef(null);

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [disabledNext, setDisabledNext] = useState(true);
    const [disabledPrev, setDisabledPrev] = useState(true);

    const [loadingDownloadCuts, setLoadingDownloadCuts] = useState(false);

    const [loadingMarkers, setLoadingMarkers] = useState(true);
    // True while later batches are still streaming in after the first batch has
    // rendered. Drives the "loading more" row at the bottom of the events list.
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [videoTitle, setVideoTitle] = useState("");
    const [analystToggle, setAnalystToggle] = useState(false);
    // When on, the list shows one entry per possession sequence instead of one
    // per event. Markers are grouped by possession_sequence_id; each group plays
    // from the first to the last event with the standard ±offset padding.
    const [groupBySequence, setGroupBySequence] = useState(false);
    // Bumped when the already-active list item is clicked again, so the playback
    // effect re-runs and replays it even though currentVideoIndex is unchanged
    // (e.g. after toggling "Group by sequences" the clip at that index differs).
    const [replayNonce, setReplayNonce] = useState(0);
    const [showAccessDeniedModal, setShowAccessDeniedModal] = useState(false);
    const [showRestrictedClipsModal, setShowRestrictedClipsModal] = useState(false);
    const [accessDeniedFromCheckbox, setAccessDeniedFromCheckbox] = useState(false);
    const [accessDeniedFromPremium, setAccessDeniedFromPremium] = useState(false);
    const allRestrictedModalShownRef = useRef(false);

    const videoPlayerRef = useRef(null);
    const [videoMarkers, setVideoMarkers] = useState([]);
    const [fallbackVideoMarkers, setFallbackVideoMarkers] = useState([]);
    // Kept-marker ids for merged playback. When the token carries a full marker
    // set (all_markers) plus a smaller kept subset (markers), excluded markers
    // break the merged sequence into separate segments. Null = merge everything.
    const [mergeKeptIds, setMergeKeptIds] = useState(null);
    const [currentOffsets, setCurrentOffsets] = useState({ begin: offset_range_begin, end: offset_range_end });
    const [currentLink, setCurrentLink] = useState("");
    const [currentSecond, setCurrentSecond] = useState(0);
    const currentLinkRef = useRef("");
    const currentSecondRef = useRef(0);
    const [beginOffset, setBeginOffset] = useState(offset_range_begin);
    const [endOffset, setEndOffset] = useState(offset_range_end);
    const beginOffsetRef = useRef(offset_range_begin);
    const endOffsetRef = useRef(offset_range_end);
    const eventsPanelRef = useRef(null);
    const precachedVideoIndicesRef = useRef(new Set());
    const playedVideoIndicesRef = useRef(new Set());
    // Clips whose /cut failed (S3 upload error, 422/no-video). Used to auto-skip
    // to the next playable clip without looping when every clip in the set fails.
    const failedVideoIndicesRef = useRef(new Set());

    const selectedEvents = useMemo(() => {
        if (videoCuts.length > 0) {
            return videoCuts.filter(item => !item.braker && item.checked);
        }
        return [];
    }, [videoCuts]);

    useEffect(() => {
        const getUserPlaylists = async () => {
            try {
                const res = await $apiV1.get('/users/playlists');
                setUserPlaylists(res.data);
            } catch (e) {
                console.log('get user playlists err', e.message);
            }
        }

        getUserPlaylists();
    }, [])

    const fetchEventsByMarkers = async (markerIds, signal) => {
        if (!Array.isArray(markerIds) || markerIds.length === 0) {
            return { events: [] };
        }

        const response = await $apiV1.post('/stats/markers_search', {
            markers: markerIds,
            video_homography: true,
            video_homography_timeline: true,
            video_homography_timeline_window: 3,
            video_homography_timeline_fill: markerIds.length === 1,
        }, { signal });

        return response?.data || { events: [] };
    };

    // Group the (possibly partial) event set and publish the counts + list. When
    // `fromBackgroundBatch` is true the list grows without restarting whatever the
    // user is currently watching.
    const applyResolvedEvents = (resolvedEvents, fromBackgroundBatch = false) => {
        // Keep the full event set for grouping so excluded markers can act
        // as merge breakpoints, but count only the kept (played) episodes.
        const hasExclusions = mergeKeptIds instanceof Set && mergeKeptIds.size > 0;
        const visibleEvents = hasExclusions
            ? resolvedEvents.filter((event) => mergeKeptIds.has(String(event?.id)))
            : resolvedEvents;
        const groupedData = groupEventsByTeam(resolvedEvents);
        const sequenceIds = new Set(
            visibleEvents
                .map((event) => event?.possession_sequence_id)
                .filter((id) => id != null)
        );
        setCountEpisode(visibleEvents.length);
        setCountMatches(groupedData.length);
        setCountSequences(sequenceIds.size);
        if (fromBackgroundBatch) {
            suppressAutoPlayRef.current = true;
        }
        setVideoCutsServer(groupedData);
    };

    const getMatchMarkers = async (primaryMarkers = [], fallbackMarkers = []) => {
        // Cancel any still-running load (marker set changed) before starting a new one.
        if (markersLoadAbortRef.current) {
            markersLoadAbortRef.current.abort();
        }
        const abortController = new AbortController();
        markersLoadAbortRef.current = abortController;
        const { signal } = abortController;

        const mergedMode = isMergedView || isSelectedOnlyMerge;
        const hasFallback =
            Array.isArray(fallbackMarkers) && fallbackMarkers.length > 0;
        // Merged/selected single-video mode (and the all_markers fallback case)
        // need the full event set to build one concatenated clip, and short lists
        // gain nothing from batching — load those in a single request.
        const loadAtOnce =
            mergedMode || hasFallback || primaryMarkers.length <= MARKER_BATCH_SIZE;

        setLoadingMarkers(true);
        setIsLoadingMore(false);
        try {
            if (loadAtOnce) {
                const primaryResponse = await fetchEventsByMarkers(primaryMarkers, signal);
                let resolvedEvents = Array.isArray(primaryResponse?.events)
                    ? primaryResponse.events
                    : [];

                const shouldRetryWithFallback =
                    resolvedEvents.length === 0 &&
                    hasFallback &&
                    !areMarkerListsEqual(primaryMarkers, fallbackMarkers);

                if (shouldRetryWithFallback) {
                    const fallbackResponse = await fetchEventsByMarkers(fallbackMarkers, signal);
                    const fallbackEvents = Array.isArray(fallbackResponse?.events)
                        ? fallbackResponse.events
                        : [];

                    if (fallbackEvents.length > 0) {
                        resolvedEvents = fallbackEvents;
                    }
                }

                applyResolvedEvents(resolvedEvents);
                setLoadingMarkers(false);
                return;
            }

            // Batched mode: resolve markers MARKER_BATCH_SIZE at a time. Render the
            // first batch immediately (the user can start watching), then keep
            // appending the remaining batches in the background. Grouping and the
            // counts are maintained incrementally (a match->group index plus a
            // running sequence set) so each batch costs O(batch) instead of
            // re-grouping the whole accumulated set every time — the previous
            // O(N^2) reprocessing was the main-thread stall on large marker lists.
            const batches = chunkArray(primaryMarkers, MARKER_BATCH_SIZE);
            const hasExclusions = mergeKeptIds instanceof Set && mergeKeptIds.size > 0;
            const groupedAccumulator = [];
            const groupIndexByMatch = new Map();
            const sequenceIdSet = new Set();
            let visibleCount = 0;

            // Coalesce background publishes. Everything downstream of
            // setVideoCutsServer (getPrepearedMarkers + the events list render)
            // runs once per publish, so publishing on every 20-marker batch would
            // re-run that pipeline dozens of times for a large marker set. Render
            // the first batch immediately, then publish at most once per
            // COALESCE_PUBLISH_MS, with a final flush after the loop.
            let lastPublishAt = 0;
            let hasPendingPublish = false;
            const publish = (fromBackgroundBatch) => {
                setCountEpisode(visibleCount);
                setCountMatches(groupedAccumulator.length);
                setCountSequences(sequenceIdSet.size);
                // A background publish only grows the list — don't restart the
                // clip the user is already watching.
                if (fromBackgroundBatch) {
                    suppressAutoPlayRef.current = true;
                }
                // Fresh top-level array ref so React re-renders; the per-group
                // marker arrays are reused where unchanged.
                setVideoCutsServer(groupedAccumulator.slice());
                lastPublishAt = Date.now();
                hasPendingPublish = false;
            };

            for (let i = 0; i < batches.length; i++) {
                const response = await fetchEventsByMarkers(batches[i], signal);
                if (signal.aborted) {
                    return;
                }
                const batchEvents = Array.isArray(response?.events)
                    ? response.events
                    : [];
                for (const event of batchEvents) {
                    const matchId = event?.match?.id;
                    if (matchId == null) continue;
                    const groupIdx = groupIndexByMatch.get(matchId);
                    if (groupIdx === undefined) {
                        groupIndexByMatch.set(matchId, groupedAccumulator.length);
                        groupedAccumulator.push({ markers: [event], match: event.match });
                    } else {
                        const group = groupedAccumulator[groupIdx];
                        group.markers = group.markers.concat(event);
                    }
                    // Count only the kept (played) episodes when exclusions apply.
                    const isVisible = !hasExclusions || mergeKeptIds.has(String(event?.id));
                    if (isVisible) {
                        visibleCount += 1;
                        if (event?.possession_sequence_id != null) {
                            sequenceIdSet.add(event.possession_sequence_id);
                        }
                    }
                }
                hasPendingPublish = true;

                if (i === 0) {
                    publish(false);
                    setLoadingMarkers(false);
                    setIsLoadingMore(batches.length > 1);
                } else if (Date.now() - lastPublishAt >= COALESCE_PUBLISH_MS) {
                    publish(true);
                }
            }
            // Flush whatever accumulated since the last coalesced publish.
            if (hasPendingPublish) {
                publish(true);
            }
            setIsLoadingMore(false);
        } catch (e) {
            if (isAbortError(e) || signal.aborted) {
                // Superseded or the page was left — drop silently.
                return;
            }
            console.log('get video cuts err', e.message);
            setCountEpisode(0);
            setCountMatches(0);
            setCountSequences(0);
            setVideoCutsServer([]);
            setLoadingMarkers(false);
            setIsLoadingMore(false);
        }
    };

    useEffect(() => {
        if (Array.isArray(videoMarkers) && videoMarkers.length > 0) {
            getMatchMarkers(videoMarkers, fallbackVideoMarkers);
        } else {
            setCountEpisode(0);
            setCountMatches(0);
            setCountSequences(0);
            setVideoCutsServer([]);
        }
        // Abort in-flight batches when the marker set changes or the page unmounts.
        return () => {
            if (markersLoadAbortRef.current) {
                markersLoadAbortRef.current.abort();
            }
        };
    }, [videoMarkers, fallbackVideoMarkers, merge_offset, mergeKeptIds]);

    

    useEffect(() => {
        let isMounted = true;
        const init = async () => {
            try {
                const token = searchParams.get('token');
                const data = await getVideoList(token);

                if (!data) return;
                const markerScope = resolveTokenMarkerSources(data);
                // Fall back to the *other* marker source: when playback runs on
                // all_markers, the kept subset (markers) is the retry list.
                const nextFallbackMarkers =
                    markerScope.selectedSource === "all_markers"
                        ? markerScope.fallbackMarkers
                        : [];

                // When both a full set (all_markers) and a kept subset (markers)
                // are present and differ, the missing ids mark merge breakpoints.
                const hasBothSources =
                    markerScope.primaryMarkers.length > 0 &&
                    markerScope.fallbackMarkers.length > 0;
                const keptForMerge =
                    hasBothSources &&
                    !areMarkerListsEqual(
                        markerScope.primaryMarkers,
                        markerScope.fallbackMarkers
                    )
                        ? new Set(markerScope.fallbackMarkers.map(String))
                        : null;

                if (isMounted) {
                    setVideoMarkers(markerScope.selectedMarkers);
                    setFallbackVideoMarkers(nextFallbackMarkers);
                    setMergeKeptIds(keptForMerge);
                    setTitle(data.title);
                }
            } catch (e) {
                console.log('init markers error', e);
            }
        };
        init();
        return () => {
            isMounted = false;
        };
    }, [searchParams]);

    const debouncedPlayVideo = useCallback(debounce(handlePlayVideo, 300), [])

    // Prepare the marker list once per data/settings change. Both effects below
    // (videoCuts and videoCutsForHandleVideo) consume the same result, so this
    // avoids running the sort/group/getVideoName pipeline twice per batch.
    const preparedMarkers = useMemo(
        () => getPrepearedMarkers(videoCutsServer),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            videoCutsServer,
            mergeKeptIds,
            groupBySequence,
            isMergedView,
            isSelectedOnlyMerge,
            offset_range_begin,
            offset_range_end,
        ]
    );

    const accessSummary = useMemo(
        () => getClipAccessSummary(videoCutsServer, mergeKeptIds),
        [videoCutsServer, mergeKeptIds]
    );
    const accessSummaryReady = !loadingMarkers && !isLoadingMore;
    const restrictedClipsMessage = accessSummaryReady && accessSummary.hasMixedAccess
        ? t('videoPlayer.restrictedClipsNotice', {
            restricted: accessSummary.restrictedClipCount,
            total: accessSummary.totalClipCount,
        })
        : '';

    useEffect(() => {
        if (!accessSummaryReady || !accessSummary.allClipsRestricted) {
            if (accessSummaryReady) {
                allRestrictedModalShownRef.current = false;
            }
            return;
        }

        if (allRestrictedModalShownRef.current) return;

        allRestrictedModalShownRef.current = true;
        setAccessDeniedFromCheckbox(false);
        setAccessDeniedFromPremium(false);
        setShowAccessDeniedModal(true);
    }, [accessSummaryReady, accessSummary.allClipsRestricted]);

    useEffect(() => {
        setVideoCuts(preparedMarkers);
        // A background batch only grows the list; don't restart the clip the user
        // is already watching. (The first batch / genuine list changes still play.)
        if (suppressAutoPlayRef.current) {
            suppressAutoPlayRef.current = false;
            return;
        }
        const videoSource = videoCutsForHandleVideo?.[currentVideoIndex] ?? currentVideo;
        if (isPlayableClip(videoSource)) {
            // Pass the base end offset; handlePlayVideo extends it for merged
            // sequence entries (adding it here too doubled the extension).
            debouncedPlayVideo(videoSource.video, videoSource.second, videoSource, null, offset_range_begin, offset_range_end, 0 , true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preparedMarkers, offset_range_begin, offset_range_end]);

    useEffect(() => {
        setVideoCutsForHandleVideo(preparedMarkers);
        // Reset precached and played videos when video list changes
        precachedVideoIndicesRef.current.clear();
        playedVideoIndicesRef.current.clear();
        failedVideoIndicesRef.current.clear();
    }, [preparedMarkers])

    useEffect(() => {
        const videoSource = videoCutsForHandleVideo[currentVideoIndex];

        // Keep prev/next availability in sync with the (possibly grown) list on
        // every update, including background-batch appends.
        if (videoSource && !videoSource.braker) {
            setDisabledPrev(
                !videoCutsForHandleVideo
                    .slice(0, currentVideoIndex)
                    .some(isPlayableClip)
            );
            setDisabledNext(
                !videoCutsForHandleVideo
                    .slice(currentVideoIndex + 1)
                    .some(isPlayableClip)
            );
        }

        // Only advance past brakers or (re)play when the selection actually
        // changed. A background batch grows videoCutsForHandleVideo without
        // changing currentVideoIndex/replayNonce; replaying then would restart
        // the current clip and keep the loading spinner up until every batch
        // arrived (the spinner-over-a-playing-video bug).
        const selectionKey = `${currentVideoIndex}:${replayNonce}`;
        if (lastPlayedSelectionRef.current === selectionKey) {
            return;
        }

        if (!videoSource) return;

        if (!isPlayableClip(videoSource)) {
            const playableIndex = findNearestPlayableClipIndex(
                videoCutsForHandleVideo,
                currentVideoIndex
            );
            if (playableIndex >= 0 && playableIndex !== currentVideoIndex) {
                setCurrentVideoIndex(playableIndex);
            }
            return;
        }

        lastPlayedSelectionRef.current = selectionKey;

        // Navigating to (or replaying) a list item drops sequence mode so the
        // chip resets to "Show full sequence" for the freshly loaded clip.
        setShowFullSequence(false);
        fullSequenceOriginRef.current = null;
        setSequenceNav({ prevMarkerId: null, nextMarkerId: null });

        if (startWithFullSequence && videoSource.id) {
            fullSequenceOriginRef.current = videoSource;
            // Reflect the selected default immediately, while the sequence
            // bounds and video cut are still loading.
            setShowFullSequence(true);
            playSequenceForMarker(videoSource.id, videoSource)
                .then((started) => {
                    // Not every older marker has a possession sequence. Keep
                    // those clips playable rather than leaving the viewer idle.
                    if (!started) {
                        setShowFullSequence(false);
                        fullSequenceOriginRef.current = null;
                        handlePlayVideo(
                            videoSource.video,
                            videoSource.second,
                            videoSource,
                            null,
                            (typeof beginOffsetRef.current === 'number') ? beginOffsetRef.current : beginOffset,
                            (typeof endOffsetRef.current === 'number') ? endOffsetRef.current : endOffset
                        );
                    }
                })
                .catch((e) => {
                    if (isAbortError(e)) return;
                    console.log('start full sequence error', e);
                    addNotification(`Show full sequence error, ${e.message}`, 'error');
                    setShowFullSequence(false);
                    fullSequenceOriginRef.current = null;
                    handlePlayVideo(
                        videoSource.video,
                        videoSource.second,
                        videoSource,
                        null,
                        (typeof beginOffsetRef.current === 'number') ? beginOffsetRef.current : beginOffset,
                        (typeof endOffsetRef.current === 'number') ? endOffsetRef.current : endOffset
                    );
                });
            return;
        }

        // Use persisted offsets when navigating; handlePlayVideo extends the
        // end offset for merged sequence entries.
        handlePlayVideo(
            videoSource.video,
            videoSource.second,
            videoSource,
            null,
            (typeof beginOffsetRef.current === 'number') ? beginOffsetRef.current : beginOffset,
            (typeof endOffsetRef.current === 'number') ? endOffsetRef.current : endOffset
        );
    }, [currentVideoIndex, videoCutsForHandleVideo, replayNonce]);

    function mergeRunIntoOne(run) {
        const first = run[0];
        const last = run[run.length - 1];
        // Name the merged clip after its first and last kept markers.
        const pairTitle = first.action && last.action
            ? (first.action === last.action ? first.action : `${first.action} - ${last.action}`)
            : `Sequence (${run.length} events)`;
        return {
            ...first,
            second: +(first.second || 0),
            end_second: +(last.second || 0),
            isMerged: true,
            action: pairTitle,
            mergedActions: run.map((m) => m.action).filter(Boolean),
        };
    }

    // Merge markers into continuous segments. A marker whose id is not in
    // keptIds was excluded by the user, so it breaks the sequence: each
    // contiguous run of kept markers becomes its own merged clip and the
    // excluded moment is skipped. With no exclusions the whole list merges
    // into a single clip (previous behaviour).
    function mergeMarkersIntoOne(markers, keptIds, selectedOnly = false) {
        if (!markers || markers.length === 0) return [];

        const sorted = [...markers].sort((a, b) => +(a.second || 0) - +(b.second || 0));
        const hasExclusions = keptIds instanceof Set && keptIds.size > 0;

        // Immediate-events mode: join ONLY the selected markers into a single
        // merged clip, ignoring any non-selected markers in the full set so they
        // never split the sequence into multiple videos.
        if (selectedOnly) {
            const keptOnly = sorted.filter(
                (marker) => !hasExclusions || keptIds.has(String(marker?.id))
            );
            if (keptOnly.length === 0) return [];
            return [
                keptOnly.length === 1 ? { ...keptOnly[0] } : mergeRunIntoOne(keptOnly),
            ];
        }

        const runs = [];
        let current = [];
        sorted.forEach((marker) => {
            const isKept = !hasExclusions || keptIds.has(String(marker?.id));
            if (isKept) {
                current.push(marker);
            } else if (current.length > 0) {
                runs.push(current);
                current = [];
            }
        });
        if (current.length > 0) {
            runs.push(current);
        }

        return runs.map((run) =>
            run.length === 1 ? { ...run[0] } : mergeRunIntoOne(run)
        );
    }

    // Group markers into one clip per possession sequence. Consecutive markers
    // sharing the same possession_sequence_id merge into a single clip spanning
    // the first-to-last event (±offset padding is applied later). Markers with no
    // sequence id (null) are never merged — each stays its own clip and also
    // breaks the current run.
    function mergeBySequence(markers) {
        if (!markers || markers.length === 0) return [];

        const sorted = [...markers].sort((a, b) => +(a.second || 0) - +(b.second || 0));

        const runs = [];
        let current = [];
        let currentSeq = undefined;
        const flush = () => {
            if (current.length > 0) {
                runs.push(current);
                current = [];
            }
        };
        sorted.forEach((marker) => {
            const seq = marker?.possession_sequence_id ?? null;
            if (seq === null) {
                flush();
                runs.push([marker]);
                currentSeq = undefined;
                return;
            }
            if (seq !== currentSeq) {
                flush();
                currentSeq = seq;
            }
            current.push(marker);
        });
        flush();

        return runs.map((run) => {
            const seqId = run[0]?.possession_sequence_id ?? null;
            // Markers without a sequence id stay as a plain single event.
            if (run.length === 1 && seqId === null) return { ...run[0] };
            // Everything with a sequence id is shown as a sequence clip — even a
            // one-event sequence, labelled "(1 event)".
            const merged = mergeRunIntoOne(run);
            merged.action = `Sequence #${seqId} (${run.length} event${run.length === 1 ? '' : 's'})`;
            return merged;
        });
    }

    function getPrepearedMarkers(videos) {
        if (!videos?.length) return []

        const hasExclusions = mergeKeptIds instanceof Set && mergeKeptIds.size > 0;
        const allMarkers = [...videos].sort((a, b) => new Date(b.match.date) - new Date(a.match.date)).reduce((res, videoCut) => {
            if (videoCut?.markers?.length > 0) {
                const headerMarkers = hasExclusions
                    ? videoCut.markers.filter((m) => mergeKeptIds.has(String(m?.id)))
                    : videoCut.markers;
                res.push({
                    braker: true,
                    // Stable, deterministic key (per match) so React reconciles the
                    // header instead of remounting it on every recompute/batch.
                    key: `braker-${videoCut.match?.id}`,
                    markers: headerMarkers,
                    match: videoCut.match,
                });
                const tmp = isMergedView
                    ? mergeMarkersIntoOne(videoCut.markers, mergeKeptIds, isSelectedOnlyMerge)
                    : groupBySequence
                    ? mergeBySequence(videoCut.markers)
                    : [...videoCut.markers].sort((a, b) => {
                        if (a?.second && b?.second && +a.second > +b.second) {
                            return 1;
                        }
                        if (a?.second && b?.second && +a.second < +b.second) {
                            return -1;
                        }
                        return 0;
                    });
                res.push(...tmp);
            }
            return res;
        }, []);
        const preparedMarkers = allMarkers
            ?.map((item) => {
                if (item?.braker) {
                    return { ...item, checked: false }
                }
                const endOffset = (item.isMerged && item.end_second != null)
                    ? (item.end_second - item.second) + offset_range_end
                    : offset_range_end;
                return {
                    ...item,
                    checked: false,
                    title: getVideoName(item, { start: offset_range_begin, end: endOffset }) ?? '',
                }
            })

        return preparedMarkers;
    }

    // A clip's /cut failed (S3 upload error, 422/no-video, or a network error).
    // Show a concise toast instead of a blocking alert(), then auto-advance to the
    // next playable clip so the user never lands on a silent black frame. The
    // failed-index set + forward-only search stop us cycling forever when every
    // clip in the set fails.
    const handleCutFailure = (reason) => {
        const failedIndex = currentVideoIndex;
        failedVideoIndicesRef.current.add(failedIndex);

        const nextIndex = pickNextPlayableIndex(
            videoCutsForHandleVideo,
            failedIndex,
            failedVideoIndicesRef.current
        );

        if (nextIndex === -1) {
            // Nothing left to try — stop here rather than loop.
            failedVideoIndicesRef.current.clear();
            addNotification('No playable videos in this set.', 'error');
            return;
        }

        addNotification("Couldn't load this clip's video — skipping to the next.", 'error');
        setCurrentVideoIndex(nextIndex);
    };

    async function handlePlayVideo(
        link,
        second,
        video,
        idx,
        range_begin,
        range_end,
        resume_second,
        resetOffsets = false
    ) {
        // Any new playback supersedes an in-flight one. Abort its network work so
        // clicking "Show full sequence" before the event clip has loaded (or
        // selecting an event while the sequence is loading) cancels the request
        // that is no longer wanted rather than waiting for it.
        if (playbackAbortRef.current) {
            playbackAbortRef.current.abort();
        }
        const playbackController = new AbortController();
        playbackAbortRef.current = playbackController;
        const playbackRequestId = ++playbackRequestIdRef.current;

        try {
            if (video?.video_blocked === true) {
                if (accessSummaryReady && accessSummary.allClipsRestricted) {
                    setAccessDeniedFromCheckbox(false);
                    setAccessDeniedFromPremium(!video?.video_premium_allowed);
                    setShowAccessDeniedModal(true);
                } else {
                    if (idx !== undefined && idx !== null && accessSummaryReady && accessSummary.hasMixedAccess) {
                        setShowRestrictedClipsModal(true);
                    }
                    const sourceIndex = idx ?? currentVideoIndex;
                    const playableIndex = findNearestPlayableClipIndex(
                        videoCutsForHandleVideo,
                        sourceIndex
                    );
                    if (playableIndex >= 0 && playableIndex !== sourceIndex) {
                        setCurrentVideoIndex(playableIndex);
                    }
                }
                return;
            }

            console.log("HANDLE PLAY IS BEING RUN:   ", resetOffsets);
            console.log("GOT RANGE BEGIN", range_begin);
            console.log("GOT RANGE END", range_end);
            if (idx !== undefined && idx !== null) {
                // Pre-store selection context immediately to avoid empty values on first open
                setCurrentVideo(video);
                setRecord(video);
                if (link != null) {
                    setCurrentLink(link);
                    currentLinkRef.current = link;
                }
                if (second != null) {
                    const secNum = typeof second === 'number' ? second : Number(second);
                    if (!Number.isNaN(secNum)) {
                        setCurrentSecond(secNum);
                        currentSecondRef.current = secNum;
                    }
                }

                setCurrentVideoIndex(idx);
                // Clicking the already-selected item leaves currentVideoIndex
                // unchanged, so the playback effect would not re-run. Bump the
                // replay nonce to force a replay of the (possibly changed) clip.
                if (idx === currentVideoIndex) {
                    setReplayNonce((n) => n + 1);
                }
                return;
            }

            setLoadingVideo(true);
            isCutLoadingRef.current = true;

            setCurrentVideo(video);
            setRecord(video);
            if (link != null) {
                setCurrentLink(link);
                currentLinkRef.current = link;
            }

            if (second != null) {
                const secNum = typeof second === 'number' ? second : Number(second);
                if (!Number.isNaN(secNum)) {
                    setCurrentSecond(secNum);
                    currentSecondRef.current = secNum;
                }
            }

        

            let currentOffSets = {
                start: (typeof range_begin === 'number') ? range_begin : (typeof beginOffsetRef.current === 'number' ? beginOffsetRef.current : beginOffset ?? offset_range_begin),
                end: (typeof range_end === 'number') ? range_end : (typeof endOffsetRef.current === 'number' ? endOffsetRef.current : endOffset ?? offset_range_end)
            }
            setCurrentOffsets({ begin: currentOffSets.start, end: currentOffSets.end });

            if (typeof range_begin === 'number') {
                setBeginOffset(range_begin);
                beginOffsetRef.current = range_begin;
                currentOffSets.start = range_begin;
                console.log("SAVED BEGIN OFFSET", range_begin);
            }

            if (typeof range_end === 'number') {
                setEndOffset(range_end);
                endOffsetRef.current = range_end;
                currentOffSets.end = range_end;
                console.log("SAVED END OFFSET", range_end);
            }

            // set offset
            if (+video?.second >= 2700 && (currentOffSets.start === 10 && currentOffSets.end === 10)) {
                currentOffSets = { start: 10, end: 25 };
            }

            console.log("OFFSET RANGE BEGIN:  ", offset_range_begin);
            console.log("OFFSET END:  ", offset_range_end);

            currentOffSets.start = offset_range_begin
            currentOffSets.end = offset_range_end;

            if (resetOffsets) {
                console.log("RESET IS TURNED ON:   ", range_begin, range_end);
                currentOffSets.start = range_begin;
                currentOffSets.end = range_end;
            } else {
                console.log("RESET IS TURNED OFF");
            }

            // Merged sequence entry: extend end offset to cover all events in the sequence.
            // Marker seconds are fractional, but the video service rejects a
            // fractional offset (422), so span the rounded seconds — the same
            // clip bounds the precache and download requests use.
            if (video?.isMerged && video?.end_second != null) {
                currentOffSets.end = (Math.round(video.end_second) - Math.round(video.second)) + currentOffSets.end;
            }

            console.log("CURRENT OFFSETS NEW:   ", currentOffSets);

            if (video) {
                // New marker responses include video_blocked and are authoritative
                // for playlist playback. Keep the endpoint fallback for older data.
                try {
                    if (typeof video.video_blocked !== 'boolean') {
                        console.log("CHECKING ACCESS FOR VIDEO:   ", video);
                        const accessResponse = await $apiV2.get(`/access/match/${video.match.id}`, {
                            signal: playbackController.signal,
                        });

                        if (!accessResponse.data?.has_access) {
                            setAccessDeniedFromCheckbox(false);
                            setShowAccessDeniedModal(true);
                            console.log("check premium 3  ",accessResponse.data?.video_premium_allowed)
                            if (!accessResponse.data?.video_premium_allowed) {
                                setAccessDeniedFromPremium(true);
                            }
                            return;
                        }
                    }
                } catch (accessError) {
                    // A superseded request must not pop the access-denied modal;
                    // let the outer handler swallow the abort quietly.
                    if (isAbortError(accessError)) {
                        throw accessError;
                    }
                    console.log('access check error', accessError);
                    // If access check fails, show access denied modal to be safe
                    setAccessDeniedFromCheckbox(false);
                    setShowAccessDeniedModal(true);
                    return;
                }

                const url = `${VIDEO_SERVICE_URL}/cut`;
                const response = await fetch(url, {
                    body: JSON.stringify({
                        offset_range_begin: currentOffSets.start,
                        offset_range_end: currentOffSets.end,
                        path: decodeURI(link),
                        start: Math.round(second),
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    signal: playbackController.signal,
                });
                const json = await response.json();
                const cutResult = classifyCutResult(json);
                if (cutResult.playable) {
                    // A clip played, so the failure streak is over — allow those
                    // indices to be retried if the user navigates back to them.
                    failedVideoIndicesRef.current.clear();
                    setVideoHref(json.data.path);
                    if (typeof resume_second === 'number') {
                        setVideoSecond(resume_second);
                    } else {
                        setVideoSecond(0);
                    }
                    // Mark current video as played
                    playedVideoIndicesRef.current.add(currentVideoIndex);
                    // Precache next 25 videos
                    precacheNextVideos();
                } else {
                    // S3 upload error / 422 / no video for this match: don't block the
                    // tab with alert() or sit on a black frame — toast + skip ahead.
                    handleCutFailure(cutResult.reason);
                }
            }
        } catch (e) {
            // This request was superseded by a newer playback — bail out quietly
            // and let the newer one own the loading state.
            if (isAbortError(e)) {
                return;
            }
            console.log('get cut video err', e);
            // Network / parse failure on this clip: same treatment as a bad cut
            // response — non-blocking toast and skip to the next playable clip.
            handleCutFailure(e?.message);
        } finally {
            // Only the latest request may clear the loading state; an aborted
            // older request must not turn the spinner off under the new load.
            if (playbackRequestId === playbackRequestIdRef.current) {
                setLoadingVideo(false);
                isCutLoadingRef.current = false;
                playbackAbortRef.current = null;
            }
        }
    };

    // Called when user tries to skip beyond current cut boundaries
    const handleExtendVideo = async (edge, overflowSeconds = 0, video = null) => {
        try {

            // (removed a redundant /users/user_profile fetch whose result was
            //  discarded — beginOffset/endOffset come from component state below)
            console.log("STARTED HANDLE EXTEND VIDEO:  ", beginOffset, endOffset);
            // Compute new window start based on edge
            const extend = Math.max(overflowSeconds, 1);

            if (edge === 'end') {

                console.log("GOT RANGE extend end ", extend);
                // pause video
                videoPause();
                // Keep same start, extend end by overflow
                const newEnd = endOffset + extend;
                console.log("NEW END", newEnd);
                setEndOffset(newEnd);
                endOffsetRef.current = newEnd;
                // compute resume time within the extended cut from current playback time
                const currentInCutPlayback = typeof videoPlayerRef.current?.getCurrentTime === 'function'
                    ? videoPlayerRef.current.getCurrentTime()
                    : 0;
                await handlePlayVideo(
                    currentLinkRef.current,
                    currentSecondRef.current,
                    currentVideo,
                    null,
                    beginOffset,
                    newEnd,
                    currentInCutPlayback,
                    true
                );
            } else if (edge === 'start') {

                console.log("GOT RANGE extend start  ", extend);

                // pause video
                videoPause();
                // Keep same anchor second, extend begin by overflow
                const newBegin = beginOffset + extend;
                console.log("NEW BEGIN", newBegin);
                setBeginOffset(newBegin);
                beginOffsetRef.current = newBegin;
                // when extending the start, keep the same original event second; resume from current playback time
                const currentInCutPlayback = typeof videoPlayerRef.current?.getCurrentTime === 'function'
                    ? videoPlayerRef.current.getCurrentTime()
                    : 0;
                await handlePlayVideo(
                    currentLinkRef.current,
                    currentSecondRef.current,
                    currentVideo,
                    null,
                    newBegin,
                    endOffset,
                    currentInCutPlayback,
                    true
                );
            } else {
                console.log("UNKNOWN EDGE  ", edge);
            }
        } catch (e) {
            console.log('extend video error', e);
        }
    };

    // "Show full sequence": ask the backend for the possession sequence the
    // current marker belongs to (start/last second across all markers sharing
    // the same possession_sequence_id in that match), then replay the current
    // clip spanning the whole sequence (±standard offsets).
    // Resolve a possession sequence by one of its marker ids and play it as a
    // merged clip spanning the whole sequence (±standard offsets). Shared by
    // "Show full sequence" and the previous/next sequence navigation. `base`
    // supplies the playback context (video link + match) and is reused for the
    // synthetic clip; the adjacent sequences live in the same match, so the same
    // base works while stepping through them. Returns true when a sequence was
    // found and playback started.
    const playSequenceForMarker = async (markerId, base) => {
        if (!markerId || !base?.video) return false;
        videoPause();
        // Cancel any in-flight playback while we resolve the sequence bounds,
        // and bail if a newer playback starts before this metadata returns.
        if (playbackAbortRef.current) {
            playbackAbortRef.current.abort();
        }
        const sequenceController = new AbortController();
        playbackAbortRef.current = sequenceController;
        const sequenceRequestId = ++playbackRequestIdRef.current;

        const response = await $apiV1.get(
            `/stats/markers/${markerId}/possession_sequence`,
            { signal: sequenceController.signal }
        );
        if (sequenceRequestId !== playbackRequestIdRef.current) {
            return false;
        }
        const data = response?.data || {};
        const startSecond = Number(data.start_second);
        const lastSecond = Number(data.last_second ?? data.end_second);

        if (!Number.isFinite(startSecond) || !Number.isFinite(lastSecond)) {
            addNotification('No sequence found for this event.', 'info');
            return false;
        }

        // Reuse the merged-clip playback path: anchor on the first second and
        // extend the end to cover the last second.
        const sequenceVideo = {
            ...base,
            second: startSecond,
            end_second: lastSecond,
            isMerged: true,
        };

        await handlePlayVideo(
            base.video,
            startSecond,
            sequenceVideo,
            null,
            offset_range_begin,
            offset_range_end,
            0,
            true
        );
        setSequenceNav({
            prevMarkerId: data.prev_marker_id ?? null,
            nextMarkerId: data.next_marker_id ?? null,
        });
        setShowFullSequence(true);
        return true;
    };

    const handleShowFullSequence = async (event) => {
        const marker = event || record;
        if (!marker?.id) return;
        try {
            // Keep the original single-event marker so "Show event only" can
            // restore it even after navigating to adjacent sequences.
            fullSequenceOriginRef.current = marker;
            await playSequenceForMarker(marker.id, marker);
        } catch (e) {
            if (isAbortError(e)) {
                return;
            }
            console.log('show full sequence error', e);
            addNotification(`Show full sequence error, ${e.message}`, 'error');
        }
    };

    // Step to the possession sequence immediately before/after the one being
    // shown. The base stays the original event's marker (same match), and the
    // origin ref is left untouched so "Show event only" still returns to the
    // event the user started from.
    const handleShowAdjacentSequence = async (direction) => {
        const targetMarkerId = direction === 'next'
            ? sequenceNav.nextMarkerId
            : sequenceNav.prevMarkerId;
        if (!targetMarkerId) return;
        const base = fullSequenceOriginRef.current || record;
        try {
            await playSequenceForMarker(targetMarkerId, base);
        } catch (e) {
            if (isAbortError(e)) {
                return;
            }
            console.log('show adjacent sequence error', e);
            addNotification(`Show ${direction} sequence error, ${e.message}`, 'error');
        }
    };

    // Inverse of handleShowFullSequence: replay just the single event that the
    // sequence was expanded from.
    const handleShowEventOnly = async (event) => {
        const origin = fullSequenceOriginRef.current || event || record;
        if (!origin?.id) return;
        try {
            videoPause();
            await handlePlayVideo(
                origin.video,
                +(origin.second || 0),
                origin,
                null,
                offset_range_begin,
                offset_range_end,
                0,
                true
            );
            setShowFullSequence(false);
            setSequenceNav({ prevMarkerId: null, nextMarkerId: null });
            fullSequenceOriginRef.current = null;
        } catch (e) {
            console.log('show event only error', e);
            addNotification(`Show event only error, ${e.message}`, 'error');
        }
    };

    const changedOffsets = async (offsetBegin, offsetEnd) => {
        console.log("RECEIVED:  " + offsetBegin + "  " + offsetEnd);
        let videoSource = videoCutsForHandleVideo[currentVideoIndex];
        if (videoSource?.braker) {
            setCurrentVideoIndex(currentVideoIndex + 1);
            return
        }
        if (!videoSource) return;
        handlePlayVideo(
            videoSource.video,
            videoSource.second,
            videoSource,
            null,
            offsetBegin,
            offsetEnd,
            0,
            true
        );
    }

    const toggleCheckCut = (checked, event) => {
        // Prevent selection if video is blocked
        if (checked && event?.video_blocked === true) {
            if (accessSummaryReady && accessSummary.allClipsRestricted) {
                setAccessDeniedFromCheckbox(false);
                console.log("check premium 1  ",event?.video_premium_allowed)
                setAccessDeniedFromPremium(!event?.video_premium_allowed);
                setShowAccessDeniedModal(true);
            }
            return;
        }

        let cuts = [...videoCuts];

        const cutIndex = cuts.findIndex((tab) => tab.id === event.id);
        if (cutIndex >= 0) {
            if (cutIndex >= 0) {
                cuts[cutIndex].checked = checked;
            }
        }
        setVideoCuts(cuts);
    }

    const toggleAllEventsOnMatch = (checked, events) => {
        // Check if any events are blocked when trying to select
        if (checked) {
            const hasBlockedEvents = events?.some((event) => event.video && event?.video_blocked === true);
            if (hasBlockedEvents && accessSummaryReady && accessSummary.allClipsRestricted) {
                setAccessDeniedFromCheckbox(false);
                const hasPremiumDenied = events?.some(
                    (event) => event.video && event?.video_blocked === true && !event?.video_premium_allowed
                );
                console.log("check premium 2  ",hasPremiumDenied)
                setAccessDeniedFromPremium(Boolean(hasPremiumDenied));
                setShowAccessDeniedModal(true);
            }
        }

        events?.forEach((event) => {
            if (event.video) {
                // Skip blocked events when trying to select them
                if (checked && event?.video_blocked === true) {
                    return;
                }
                // Call toggleCheckCut for non-blocked events
                // We skip blocked ones above to avoid double modal (already shown above)
                toggleCheckCut(checked, event);
            }
        })
    }

    const toggleAllEvents = (checked) => {
        toggleAllEventsOnMatch(checked, videoCuts)
    }

    const handleEmailChange = (newValue) => {
        setFolderName(newValue);
    };

    // const getCutVideo = async (params) => {
    //     const result = await $apiV1.post(
    //         `${VIDEO_SERVICE_URL}/cut_video/`,
    //         params,
    //     );

    //     return result
    // }

    const addNewFolder = async () => {

        try {
            console.log("RECORD  ", record);
            setLoadingAddPlaylist(true);
            let playlist;

            if (!selectedPlaylist) {
                // First API request to create a new folder
                const createFolderResponse = await $apiV1.post(`/users/playlists`,
                    { title: folderName },
                );
                playlist = createFolderResponse.data;
                trackPlaylistAction({
                    action: 'create',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || folderName,
                    sourceSurface: 'video',
                });
                setUserPlaylists(prev => [playlist, ...prev])
            } else {
                playlist = selectedPlaylist;
            }

            setOpenAddVide(!openAddVideo);

            if (record?.id && recordTime?.startTime && recordTime?.endTime) {
                const params = {
                    end_second: (record.second - offset_range_begin)  + +(+recordTime.endTime).toFixed(0),
                    start_second:  (record.second - offset_range_begin)  + +(+recordTime.startTime).toFixed(0),
                    type: 'R',
                    event_id: record.id,
                    title: videoTitle || `Record from ${recordTime.startTime.toFixed(0)} to ${recordTime.endTime.toFixed(0)}`
                }
                // await getCutVideo(params);
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    [params],
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        clip_end_second: params.end_second,
                        clip_start_second: params.start_second,
                        event_id: record?.id,
                    },
                    sourceSurface: 'video',
                });
                
                return
            }

            // Ensure selectedCheckboxes is an array of event_ids
            const events = selectedEvents?.length > 0
                ? selectedEvents.map((event) => ({
                    event_id: event.id,
                    title: event.title,
                }))
                : [];

            if (events?.length !== 0) {
                // Second API request to add events to the newly created folder
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    events,
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        added_events_count: events.length,
                        event_ids: events.map((event) => event?.event_id).filter(Boolean),
                    },
                    sourceSurface: 'video',
                });
                videoCuts?.map(item => toggleCheckCut(false, item));
            }

            // You can handle the response of the second API request here if needed
            // setCheck(addEventsResponse.data);
            // setOpenAddVide(!openAddVideo);
        } catch (error) {
            setFolderName('');
            console.error("Error processing request:", error);
        } finally {
            setFolderName('');
            setLoadingAddPlaylist(false);
        }
    };

    const handleSelectChange = (value) => {
        setSelectedPlaylist(value);
    };

    const addRecordToPlaylist = () => {
        setOpenAddVide(true);
    }

    const handlePrevVideo = () => {
        // Walk back to the previous playable clip, skipping braker headers.
        // The first list item is always a braker, so stop before index -1.
        for (let idx = currentVideoIndex - 1; idx >= 0; idx -= 1) {
            const videoSource = videoCutsForHandleVideo[idx];
            if (isPlayableClip(videoSource)) {
                setCurrentVideoIndex(idx);
                return;
            }
        }
    };

    const handleNextVideo = () => {
        for (let idx = currentVideoIndex + 1; idx < videoCutsForHandleVideo.length; idx += 1) {
            const videoSource = videoCutsForHandleVideo[idx];
            if (isPlayableClip(videoSource)) {
                setCurrentVideoIndex(idx);
                return;
            }
        }
    };


    const prepeareCutsForServer = (data) => {
        // eslint-disable-next-line consistent-return,array-callback-return
        const cuts = Object.entries(data).map(([key, values]) => {
            const path = decodeURI(values.video);
            const start = Math.round(+values.second) - offset_range_begin < 0 ? 0 : Math.round(+values.second) - offset_range_begin;
            // Merged sequence clips span up to end_second, not just the first event.
            const lastSecond = (values.isMerged && values.end_second != null)
                ? +values.end_second
                : +values.second;
            return {
                end: Math.round(lastSecond) + offset_range_end,
                path,
                start,
            };
        });
        return cuts;
    };

    const precacheNextVideos = useCallback(() => {
        if (!videoCutsForHandleVideo || videoCutsForHandleVideo.length === 0) return;
        
        // Count how many precached videos remain ahead that haven't been played
        let remainingPrecachedCount = 0;
        for (let i = currentVideoIndex + 1; i < videoCutsForHandleVideo.length; i++) {
            const video = videoCutsForHandleVideo[i];
            // Skip braker items
            if (video.braker) continue;
            // Count only precached videos that haven't been played
            if (precachedVideoIndicesRef.current.has(i) && !playedVideoIndicesRef.current.has(i)) {
                remainingPrecachedCount++;
            }
        }

        // Only precache if there are 3 or fewer precached videos remaining
        if (remainingPrecachedCount > 3) return;

        // Collect the next 25 videos with their actual indices
        const videosToPrecache = [];
        for (let i = currentVideoIndex + 1; i < videoCutsForHandleVideo.length && videosToPrecache.length < 25; i++) {
            const video = videoCutsForHandleVideo[i];
            // Skip braker items and videos without valid data
            if (isPlayableClip(video) && video.second != null) {
                videosToPrecache.push({ video, index: i });
            }
        }

        if (videosToPrecache.length === 0) return;

        // Check which videos haven't been precached yet
        const newVideos = videosToPrecache.filter(({ index }) => !precachedVideoIndicesRef.current.has(index));

        // If all videos are already precached, don't send request
        if (newVideos.length === 0) return;

        // Build payload array only for new videos
        const payload = newVideos.map(({ video }) => {
            const second = typeof video.second === 'number' ? video.second : Number(video.second);
            const start = Math.round(second) - offset_range_begin < 0 ? 0 : Math.round(second) - offset_range_begin;
            // Merged sequence clips span up to end_second, not just the first event.
            const lastSecond = (video.isMerged && video.end_second != null)
                ? Number(video.end_second)
                : second;
            const end = Math.round(lastSecond) + offset_range_end;
            const path = decodeURI(video.video);

            return {
                start,
                end,
                path
            };
        });

        // Mark all videos in the range as precached (even if some were already precached)
        videosToPrecache.forEach(({ index }) => {
            precachedVideoIndicesRef.current.add(index);
        });

        // Fire and forget - don't wait for response
        fetch('https://video-platform.smrtstats.com/batch/cut/files', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }).catch(err => {
            // Silently ignore errors for precaching
            console.log('Precache error (ignored):', err);
        });
    }, [videoCutsForHandleVideo, currentVideoIndex, offset_range_begin, offset_range_end]);

    // Re-precache when offsets change
    useEffect(() => {
        // Check if offsets actually changed (not just initial mount or other deps)
        const beginChanged = beginOffsetRef.current !== offset_range_begin;
        const endChanged = endOffsetRef.current !== offset_range_end;
        
        if (beginChanged || endChanged) {
            console.log("OFFSET ACTUALLY CHANGED - triggering precache:  ", offset_range_begin, offset_range_end);
            // Update refs to new values
            beginOffsetRef.current = offset_range_begin;
            endOffsetRef.current = offset_range_end;
            // Clear precached indices since offsets changed (cached videos used old offsets)
            precachedVideoIndicesRef.current.clear();
            // Re-precache with new offsets if we have videos
            if (videoCutsForHandleVideo && videoCutsForHandleVideo.length > 0 && currentVideoIndex >= 0) {
                precacheNextVideos();
            }
        }
    }, [offset_range_begin, offset_range_end, precacheNextVideos, videoCutsForHandleVideo, currentVideoIndex]);

    const handleDownloadSelectedCuts = async () => {
        setLoadingDownloadCuts(true);
        try {
            let data = [];
            if (selectedEvents?.length === 0 && videoCuts?.length > 0) {
                data = videoCuts?.filter(item => !Boolean(item.braker))
            } else {
                data = selectedEvents;
            }
            const cuts = prepeareCutsForServer(
                data.filter((item) => Boolean(item.video) && item.video_blocked !== true),
            );
            if (cuts.length > 0) {
                const controller = new AbortController();
                addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
                document.body.classList.add("loading-cursor");
                const url = `${VIDEO_SERVICE_URL}/batch/cut/zip`;
                videoPause();
                const response = await fetch(url, {
                    body: JSON.stringify(cuts),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    signal: controller.signal
                });
                const json = await response.json();
 
                if (json.data && json.data.path) {
                    const a = document.createElement('a');
                    a.href = json.data.path;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
        
                if (json.errors && json.errors.length) {
                    addNotification(`Get zip archive error: ${json.errors.join(" , ")}`, 'error')
                }
            } else {
                addNotification('There are no videos available for download', 'error')
            }
        } catch (e) {
            addNotification(`Get zip archive error, ${e.message}`, 'error')
        } finally {
            setLoadingDownloadCuts(false);
            document.body.classList.remove("loading-cursor");
        }
    };

    const handleDownloadSelectedCutsInOneClip = async () => {
        setLoadingDownloadCuts(true);
        try {
            let data = [];
            if (selectedEvents?.length === 0 && videoCuts?.length > 0) {
                data = videoCuts?.filter(item => !Boolean(item.braker))
            } else {
                data = selectedEvents;
            }
            const cuts = prepeareCutsForServer(
                data.filter((item) => Boolean(item.video) && item.video_blocked !== true),
            );
            if (cuts.length > 0) {
                const controller = new AbortController();
                addNotification(`Fetching clips in one clip. Please don't close or refresh the page till the download is completed.`, "info", controller);
                document.body.classList.add("loading-cursor");
                const url = `${VIDEO_SERVICE_URL}/batch/cut/video`;
                videoPause();
                const response = await fetch(url, {
                    body: JSON.stringify(cuts),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    signal: controller.signal
                });
                const json = await response.json();
                if (json.data && json.data.path) {
                    const a = document.createElement('a');
                    a.href = `${json.data.path}?download=true`;
                    a.rel = 'noopener noreferrer';
                    a.download = json.data.hash;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    videoPlay();
                }
        
                if (json.errors && json.errors.length) {
                    addNotification(`Get video error: ${json.errors.join(" , ")}`, 'error')
                    videoPlay();
                }
            } else {
                addNotification('There are no videos available for download', 'error')
            }
        } catch (e) {
            addNotification(`Get zip archive error, ${e.message}`, 'error')
        } finally {
            setLoadingDownloadCuts(false);
            document.body.classList.remove("loading-cursor");
        }
    };

    const modal = (
        <Modal isOpen={openAddVideo} setIsOpen={setOpenAddVide} closeIc>
            <h1>
                {
                    record && recordTime?.startTime && recordTime?.endTime
                        ? l(1027)
                        : `Add ${selectedEvents?.length} events to Playlist `
                }
            </h1>
            <FormWrapPopup style={{ marginTop: "20px" }}>
                <Dropdown>
                    <DropdownButton
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        {!selectedPlaylist
                            ? `${l(1088)}`
                            : `${selectedPlaylist?.title}`}
                        <img src={showDropdown ? arrowIconUp : arrowIconDown} />
                    </DropdownButton>
                    <DropdownContent $show={showDropdown}>
                        {userPlaylists.map((item) => (
                            <DropdownItem
                                key={item.id}
                                selected={item.id === selectedPlaylist?.id}
                                onClick={() => handleSelectChange(item)}
                            >
                                {item.title}
                            </DropdownItem>
                        ))}
                    </DropdownContent>
                </Dropdown>
                <TextInput
                    label={l(1089)}
                    type={"text"}
                    value={folderName}
                    placeholder={l(1090)}
                    onChange={handleEmailChange}
                />
                {recordTime?.startTime && recordTime?.endTime && (
                <TextInput
                    label={l(1108)}
                    type={"text"}
                    value={videoTitle}
                        placeholder={l(1108)}
                        onChange={setVideoTitle}
                    />
                )}
            </FormWrapPopup>
            <Button
                style={{ zIndex: 1 }}
                title="Add to playlist"
                size={"full"}
                onClick={() => addNewFolder()}
                disabled={loadingAddPlaylist}
            />
        </Modal>
    );

    const videoPause = () => {
        videoPlayerRef.current?.pause();
    };

    const videoPlay = () => {
        videoPlayerRef.current?.play();
    };

    const toggleVideo = () => {
        videoPlayerRef.current?.togglePlay();
    };

    const handleToggleAnalystMode = () => {
        const next = !analystToggle
        setAnalystToggle(next);
        // When analyst mode is active, navigation is hidden completely
        // No need to manipulate localStorage or dispatch events
    }

    return (
        <MainWrapper>
            {!analystToggle && <Navigation />}
            <VideoWrapper className={
                analystToggle ? "fullWidthPage" : 
                localStorage.getItem("navigationOpen") === "true"
                    ? ""
                    : "fullWidthPage"
            }>
                <TopWrapper $stacked={analystToggle}>
                    <FocusLayer $focus={analystToggle}>
                        <IntroText title={title} stacked={analystToggle} />
                    </FocusLayer>
                </TopWrapper>
                {/* overlay for analyst mode */}
                <AnalystOverlay $visible={analystToggle} />
                <VideoPlayerWrapper $stacked={analystToggle}>
                    <EventsPanel
                        ref={eventsPanelRef}
                        stacked={analystToggle}
                        toggleAllEvents={toggleAllEvents}
                        countEpisodes={countEpisode}
                        countMathes={countMatches}
                        countSequences={countSequences}
                        videoCuts={videoCuts}
                        handlePlayVideo={handlePlayVideo}
                        toggleCheckCut={toggleCheckCut}
                        toggleAllEventsOnMatch={toggleAllEventsOnMatch}
                        selectedEventsCount={selectedEvents?.length || 0}
                        onOpenAddPlaylistModal={(bool) => {
                            setRecord(null);
                            setOpenAddVide(bool)
                        }}
                        currentVideoIndex={currentVideoIndex}
                        loadingDownloadCuts={loadingDownloadCuts}
                        handleDownloadSelectedCuts={handleDownloadSelectedCuts}
                        handleDownloadSelectedCutsInOneClip={handleDownloadSelectedCutsInOneClip}
                        loadingMarkers={loadingMarkers}
                        isLoadingMore={isLoadingMore}
                        onShowAccessDenied={(premiumDenied) => {
                            if (!accessSummaryReady || !accessSummary.allClipsRestricted) {
                                return;
                            }
                            if (premiumDenied) {
                                setAccessDeniedFromPremium(true);
                            } 
                            setAccessDeniedFromCheckbox(true);
                            setShowAccessDeniedModal(true);
                        }}
                        restrictedClipsMessage={restrictedClipsMessage}
                    />

                    <VideoContent $focus={analystToggle} $stacked={analystToggle}>
                        <AnalystToggleWrap className="analyst-toggle-container" $stacked={analystToggle} style={{position: 'absolute', top: '-30px', right: '2px'}}>
                            <div data-tour="video-group-sequences" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div onClick={() => setGroupBySequence((v) => !v)} style={{ color: 'white', fontSize: '16px', fontFamily: 'SatoshiBold', cursor: 'pointer' }}>
                                    Group by sequences
                                </div>
                                <ToggleSwitch>
                                    <ToggleInput
                                        type="checkbox"
                                        checked={groupBySequence}
                                        onChange={() => setGroupBySequence((v) => !v)}
                                    />
                                    <ToggleSlider />
                                </ToggleSwitch>
                            </div>
                            <div data-tour="video-analyst-mode" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div className="analyst-toggle-text" onClick={handleToggleAnalystMode} style={{ color: 'white', fontSize: '16px', fontFamily: 'SatoshiBold', cursor: 'pointer' }}>
                                    {l(1113)}
                                </div>
                                <ToggleSwitch>
                                    <ToggleInput
                                        type="checkbox"
                                        checked={analystToggle}
                                        onChange={handleToggleAnalystMode}
                                    />
                                    <ToggleSlider />
                                </ToggleSwitch>
                            </div>
                        </AnalystToggleWrap>
                        <VideoPlayer
                            ref={videoPlayerRef}
                            styleWrapper={{ width: analystToggle ? '100%' : '95%' }}
                            video={videoHref}
                            toSecond={videoSecond}
                            playNextVideo={handleNextVideo}
                            playPrevVideo={handlePrevVideo}
                            videos={videoCuts}
                            loading={loadingVideo}
                            isLoadingRef={isCutLoadingRef}
                            record={record}
                            setRecord={setRecord}
                            recordTime={recordTime}
                            setRecordTime={setRecordTime}
                            addRecordToPlaylist={addRecordToPlaylist}
                            disabledNext={disabledNext}
                            disabledPrev={disabledPrev}
                            onExtendVideo={handleExtendVideo}
                            stacked={analystToggle}
                            changedOffsets={changedOffsets}
                            onShowFullSequence={handleShowFullSequence}
                            onShowEventOnly={handleShowEventOnly}
                            onShowPreviousSequence={() => handleShowAdjacentSequence('prev')}
                            onShowNextSequence={() => handleShowAdjacentSequence('next')}
                            hasPreviousSequence={!!sequenceNav.prevMarkerId}
                            hasNextSequence={!!sequenceNav.nextMarkerId}
                            isFullSequenceActive={showFullSequence}
                            activeEvent={record}
                            eventOffsetBegin={offset_range_begin}
                        />
                    </VideoContent>
                </VideoPlayerWrapper>
            </VideoWrapper>
            {modal}
            <Modal isOpen={showAccessDeniedModal} setIsOpen={setShowAccessDeniedModal} closeIc>
                <h1>
                    {accessDeniedFromPremium ? l(1608) : l(1610)}
                </h1>
                <p>
                    {accessDeniedFromPremium
                        ? (l(1609) || '').replace(
                            '*X*',
                            videoSettings?.can_access_video_after ?? '*X*'
                        )
                        : accessDeniedFromCheckbox
                            ? l(1611)
                            : l(1612)}
                </p>
                <br></br>
                <Button
                    title="Close"
                    size={"full"}
                    onClick={() => {
                        setShowAccessDeniedModal(false);
                        setAccessDeniedFromCheckbox(false);
                        setAccessDeniedFromPremium(false);
                    }}
                />
            </Modal>
            <Modal isOpen={showRestrictedClipsModal} setIsOpen={setShowRestrictedClipsModal} closeIc>
                <h1>{t('videoPlayer.restrictedClipsTitle')}</h1>
                <p>{restrictedClipsMessage}</p>
                <br></br>
                <Button
                    title="Close"
                    size={"full"}
                    onClick={() => setShowRestrictedClipsModal(false)}
                />
            </Modal>
            {/* display notifications */}
            <NotificationList
                notifications={notifications}
                onClose={removeNotification}
            />
            <VideoTutorial />
        </MainWrapper>
    )
}

export default VideoListUpdatedV2;
